import React from "react";

const CheckInView = (props) => {
    let {run, pickup, onLocationCheckin, enableEdit} = props;

    if(pickup.isCheckIn && !run.isBaseCheckedIn && enableEdit){
        return (
            <div className="row mt-1">
                <div className="col-12 text-right">
                    <button type="button" className="btn btn-primary" onClick={onLocationCheckin}>Check-in</button>
                </div>
            </div>);
    } else {
        return null;
    }
};

export default CheckInView;